import { useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';

import AppHeader from '@/components/headers/app-header';
import useGetCurrentUser from '@/hooks/user/useGetCurrentUser';
import { getCurrentUser } from '@/services/utils/currentUser';

function AppLayout() {
    const { pathname } = useLocation();
    const hasStories = useSelector(
        (state) => state.appLayoutReducer.shouldAdjustBasedOnStories,
    );
    const user = useGetCurrentUser();

    const isLoggedIn = () => !isEmpty(user) || !isEmpty(getCurrentUser());

    const marginTop = useMemo(() => {
        if (pathname.includes('wallet')) {
            return '100px';
        }

        if (pathname.includes('onboarding')) {
            return '80px';
        }

        if (pathname.endsWith('/store') || pathname.endsWith('/offers')) {
            // return hasStories ? '340px' : '140px';
            return '140px';
        }

        // return hasStories ? '235px' : '75px';
        return '75px';
    }, [pathname, hasStories]);

    return (
        <div
            style={!isLoggedIn() ? { visibility: 'hidden' } : {}}
            className="container  pos-relative mh-100vh  d-flex flex-column"
        >
            <AppHeader />

            <div className="d-flex flex-grow-1" style={{ marginTop }}>
                <Outlet />
            </div>
        </div>
    );
}

export default AppLayout;
